import { createBrowserRouter } from "react-router-dom";
import AdminRoutes from "./admin/routes"
import PublicRoutes from "./public/routes"
import CustomerDashboardRoutes from "./dashboard/routes";
import { getMode } from "./util/functions";


const APP_MODE = getMode();

console.log('APP_MODE: ', APP_MODE);

const getRoutes = () => {
    if (APP_MODE === "admin") return createBrowserRouter(AdminRoutes);
    return createBrowserRouter([...PublicRoutes, ...CustomerDashboardRoutes]);
};

export default getRoutes;
